import { utcWeek, utcMonth, utcYear } from 'd3'

const periods = {
  'YTD': fromDate => utcYear.floor(fromDate),
  '1W': fromDate => utcWeek.offset(fromDate, -1),
  '1M': fromDate => utcMonth.offset(fromDate, -1),
  '3M': fromDate => utcMonth.offset(fromDate, -3),
  '6M': fromDate => utcMonth.offset(fromDate, -6),
  '1Y': fromDate => utcYear.offset(fromDate, -1),
  '3Y': fromDate => utcYear.offset(fromDate, -3),
  '5Y': fromDate => utcYear.offset(fromDate, -5),
  '10Y': fromDate => utcYear.offset(fromDate, -10),
  'INC': () => -Infinity,
  'PCY': fromDate => utcYear.floor(fromDate),
  'Q1': fromDate => utcMonth.offset(fromDate),
  'Q2': fromDate => utcMonth.offset(fromDate),
  'Q3': fromDate => utcMonth.offset(fromDate),
  'Q4': fromDate => utcMonth.floor(fromDate),
}

export { periods }


// WEBPACK FOOTER //
// ./src/periods.js